<div class="row">
    <div class="col-12">
        <div class="no-data not-found-wrap" style="height: calc(100vh - 110px);">
            <div class="d-flex align-items-center flex-column">
                <img src="assets/images/icons/forbidden.svg" alt="">
                <h1 class="not-found-text">403</h1>
                <p class="text-center">{{forbidden_msg}}</p>
            </div>
        </div>
    </div>
</div>